export const extractFundKeyUsingTrancheName = (tranche: string): string => {
  return tranche.replace(/-\d{8}$/, '');
};
